import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AnnualLeaseService } from '@app/landowner-admin-shared/services/annual-lease.service';
import AnnualLease from '@app/models/annual-lease';
import LeaseSeasonViewModel from '@app/models/lease-season-view-model';
import PagedResults from '@app/models/paged-results';
import SeasonLookupViewModel from '@app/models/season-lookup-view-model';
import {
  AppSettingsService,
  ArrayService,
  DateService,
  ErrorHelperService,
  ListingService,
  LogService,
  NotificationService,
  RouteHelperService,
  UserService,
  ValueService,
} from '@app/services';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import LeaseSeasonGridContextType from './lease-season-grid-context.enum';
import { LeaseSeasonFormComponent } from '../lease-season-form/lease-season-form.component';
import { SpinnerComponent } from '../../../common-components/spinner/spinner.component';
import { OAPopoverComponent } from '../../../common-components/oapopover/oapopover.component';
import { NgIf, NgFor, NgClass, DatePipe } from '@angular/common';
import { NgbModal, NgbModalRef, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: "lease-season-grid",
    templateUrl: "./lease-season-grid.component.html",
    styleUrls: ["./lease-season-grid.component.less"],
    imports: [NgIf, NgFor, OAPopoverComponent, NgClass, SpinnerComponent, NgbModalModule, LeaseSeasonFormComponent, DatePipe]
})
export class LeaseSeasonGridComponent implements OnInit, OnDestroy {
  private readonly _componentName = 'LeaseSeasonGridComponent';
  private pagedResult: PagedResults;
  private _lease: AnnualLease;
  /**
   * Subject to control observable completion
   */
  private unSubSub$ = new Subject<void>();

  private showDevComments$: Subscription;

  public LeaseSeasonGridContextType = LeaseSeasonGridContextType;

  @Input()
  public showReproductionMethod = false;

  @Input()
  public rows: SeasonLookupViewModel[] = [];

  @Input()
  public title: string;

  public retrieving = false;

  @Input()
  public showDescription = false;

  /**
   * Grid is not displayed if there are no rows
   */
  @Input()
  public hideIfEmpty = false;

  @ViewChild("leaseSeasonFormModal") leaseSeasonFormModal: TemplateRef<any>;
  modal: NgbModalRef;
  @Input()
  public contextType: LeaseSeasonGridContextType = LeaseSeasonGridContextType.Lease;

  @Output()
  public change = new EventEmitter<LeaseSeasonViewModel[]>();

  public leaseSeasons: LeaseSeasonViewModel[] = [];

  public listingLeaseSeasons: LeaseSeasonViewModel[] = [];

  public selectedLeaseSeason: LeaseSeasonViewModel;

  /**
   * Flag to show developer comments in a comment
   */
  public showDevComments: boolean;

  constructor(
    private log: LogService,
    private notify: NotificationService,
    private listingService: ListingService,
    private dateService: DateService,
    private valueService: ValueService,
    private arrayService: ArrayService,
    private appSettings: AppSettingsService,
    private userService: UserService,
    private router: Router,
    private routeHelper: RouteHelperService,
    private route: ActivatedRoute,
    private errorHelper: ErrorHelperService,
    private annualLeaseService: AnnualLeaseService,
    private modalService: NgbModal
  ) {
    this.showDevComments$ = log.showDevComments.subscribe((x) => (this.showDevComments = x));
  }

  ngOnInit() {
    
  }

  
  ngOnDestroy(): void {
    this.unSubSub$.next(void 0);
    this.unSubSub$.complete();

    if (this.showDevComments$) {
      this.showDevComments$.unsubscribe();
    }
  }

  public get lease(): AnnualLease {
    return this._lease;
  }

  @Input()
  public set lease(v: AnnualLease) {
    console.log(`${this._componentName}.lease - set - 39db7 -  v=`, v);
    this._lease = v;

    this.retrieve();

    this.retrieveLeaseSeasons();
  }

  public retrieveLeaseSeasons() {
    this.annualLeaseService
      .getLeaseSeasons(this.lease.listingId)
      .pipe(takeUntil(this.unSubSub$))
      .subscribe(
        (result) => {
          console.log(`${this._componentName}.retrieve() - getLeaseSeasons subscription - 39db7 - result=`, result);

          // Lease Seasons for the current annual lease

          switch (this.contextType) {
            case LeaseSeasonGridContextType.Listing:
              this.leaseSeasons = result.filter((x) => x.annualLeaseId !== this.lease.id && x.listingId === this.lease.listingId);
              break;

            case LeaseSeasonGridContextType.Lease:
              this.leaseSeasons = result.filter((x) => x.annualLeaseId === this.lease.id);
              this.listingLeaseSeasons = result.filter((x) => x.annualLeaseId !== this.lease.id && x.listingId === this.lease.listingId);

              this.leaseSeasons.forEach((x) => (x.canEdit = true));
              this.leaseSeasons.forEach((x) => (x.canDelete = true));

              break;

            default:
              break;
          }

          this.retrieving = false;
        },
        (err) => {
          console.error(err);

          const msg = this.errorHelper.getErrorMessage(err) || 'A subscription error occured';

          console.error(msg);

          
          this.notify.error(msg, null);

          this.retrieving = false;
        }
      );
  }

  /**
   * Retrieves season lookup data from the  Web API
   */
  public retrieve() {
    console.log(`${this._componentName}.retrieve()- 39db7`);

    if (!this.lease) return;

    this.retrieving = true;

    this.annualLeaseService
      .getSeasonLookup(this.lease.secureAlternateId, this.lease.listingId)
      .pipe(takeUntil(this.unSubSub$))
      .subscribe(
        (result) => {
          console.log(`${this._componentName}.retrieve() - getStateSeasonLookups subscription - 39db7 - result=`, result);

          this.rows = result;
          this.retrieving = false;
        },
        (err) => {
          console.error(err);

          const msg = this.errorHelper.getErrorMessage(err) || 'A subscription error occured';

          console.error(msg);

          
          this.notify.error(msg, null);

          this.retrieving = false;
        }
      );
  }


  /**
   * Is verbose logging enabled
   */
  private get verboseLogging(): boolean {
    return true;
    // return this.log.verboseLogging;
  }

  public onRowClick(r: SeasonLookupViewModel) {}

  public onEditClick(leaseSeason: LeaseSeasonViewModel) {
    if (this.verboseLogging) {
      console.log(`${this._componentName}.onEditClick() leaseSeason=`, leaseSeason);
    }

    this.selectedLeaseSeason = { ...leaseSeason };

    this.modal = this.modalService.open(this.leaseSeasonFormModal);
  }

  public onDeleteClick(leaseSeason: LeaseSeasonViewModel) {
    if (this.verboseLogging) {
      console.log(`${this._componentName}.onDeleteClick() leaseSeason=`, leaseSeason);
    }

    this.leaseSeasons.splice(
      this.leaseSeasons.findIndex((item) => item.secureAlternateId === leaseSeason.secureAlternateId),
      1
    );

    this.refreshConflicts();

    this.change.emit(this.leaseSeasons);
  }

  public onSaveLeaseSeasonClick(leaseSeason: LeaseSeasonViewModel) {
    console.log(`${this._componentName}.onSaveLeaseSeasonClick leaseSeason=`, leaseSeason);

    const i = this.leaseSeasons.findIndex((x) => x.secureAlternateId === leaseSeason.secureAlternateId);

    if (i >= 0) {
      this.leaseSeasons[i] = leaseSeason;
      this.selectedLeaseSeason = null;
    } else {
      this.leaseSeasons.push(leaseSeason);
      this.selectedLeaseSeason = null;
    }

    this.modal.close();

    this.refreshConflicts();

    this.change.emit(this.leaseSeasons);
  }

  public onCancelLeaseSeasonClick() {
    this.selectedLeaseSeason = null;
    this.modal.close();
  }

  /**
   * Adds a season lookup as a lease season
   */
  public addLeaseSeason(seasonLookup: SeasonLookupViewModel) {
    console.log(`${this._componentName}.addLeaseSeason seasonLookup:`, seasonLookup);

    console.log(`${this._componentName}.addLeaseSeason lease:`, this.lease);

    this.addLeaseSeasons([seasonLookup]);
  }

  /**
   * Adds season lookups as lease seasons
   */
  public addLeaseSeasons(seasonLookups: SeasonLookupViewModel[]) {
    console.log(`${this._componentName}.addLeaseSeasons seasonLookup:`, seasonLookups);
    console.log(`${this._componentName}.addLeaseSeasons lease:`, this.lease);

    for (let index = 0; index < seasonLookups.length; index++) {
      const seasonLookup = seasonLookups[index];
      var leaseSeason = this.annualLeaseService.createLeaseSeason(seasonLookup);

      const leaseSeasonViewModel: LeaseSeasonViewModel = {
        ...leaseSeason,
        listingId: this.lease.listingId,
        annualLeaseId: this.lease.id,
        secureAlternateId: this.valueService.generateUUID(),
        annualLeaseName: this.lease.name,
        createdByEmailAddress: null,
        updatedByEmailAddress: null,
        listingAdminUrl: null,
        listingUrl: null,
        selected: false,
        hasConflict: false,
        canEdit: true,
        canDelete: true,
      };

      // this.annualLeaseService.checkValidityForNewAnnualLease;
      this.leaseSeasons.push(leaseSeasonViewModel);
    }

    this.refreshConflicts();

    this.change.emit(this.leaseSeasons);
  }

  public onCreateClick() {
    console.log(`${this._componentName}.onCreateClick`);

    const leaseSeasonViewModel: LeaseSeasonViewModel = {
      listingId: this.lease.listingId,
      annualLeaseId: this.lease.id,
      secureAlternateId: this.valueService.generateUUID(),
      annualLeaseName: this.lease.name,
      createdByEmailAddress: null,
      updatedByEmailAddress: null,
      listingAdminUrl: null,
      listingUrl: null,
      selected: false,
      hasConflict: false,
      canEdit: true,
      canDelete: true,
      createdOn: this.dateService.nowUTC,
      createdBy: this.userService.userId,
      startDateTime: this.dateService.nowUTC,
      endDateTime: this.dateService.thirtyDaysFromNow(),
      seasonLookupId: 0,
      updatedOn: null,
      updatedBy: null,
      reproductionMethod: null,
      reproductionDescription: null,
      predecessorAlternateId: null,
      id: 0,
      name: null,
      description: null,
    };

    this.selectedLeaseSeason = leaseSeasonViewModel;

    this.modal = this.modalService.open(this.leaseSeasonFormModal);
  }

  private refreshConflicts() {
    this.leaseSeasons.forEach((leaseSeasonViewModel) => {
      let b = false;

      var overlappingListingLeaseSeason = this.listingLeaseSeasons.filter((s) => {
        if (
          this.dateService.overlaps(s.startDateTime, s.endDateTime, leaseSeasonViewModel.startDateTime, leaseSeasonViewModel.endDateTime)
        ) {
          return s;
        }
      });

      // 2022-03-03 - Removed the conflict detect check for lease seasons on the same annual lease.  These are now allowed.
      // var overlappingLeaseSeason = this.leaseSeasons
      //   .filter((x) => x.secureAlternateId !== leaseSeasonViewModel.secureAlternateId)
      //   .filter((s) => {
      //     if (
      //       this.dateService.overlaps(s.startDateTime, s.endDateTime, leaseSeasonViewModel.startDateTime, leaseSeasonViewModel.endDateTime)
      //     ) {
      //       return s;
      //     }
      //   });
      // if (overlappingLeaseSeason.length > 0 || overlappingListingLeaseSeason.length > 0) {

      if (overlappingListingLeaseSeason.length > 0) {
        b = true;
      }

      leaseSeasonViewModel.hasConflict = b;
    });
  }
}
